module.exports = __webpack_public_path__ + "img/product-category-weddingrings@2x.b0f0594.jpg";